import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { Checkbox, Icon } from '@haldor/ui';
import { useDispatch, useSelector } from 'react-redux';
import { Collapsible, Spinner } from 'UI';
import Plus from 'UI/IconsSrc/plus';
import { translate as getTranslate } from '@haldor/ui';
import Minus from 'UI/IconsSrc/minus';
import SearchGroups from './SearchGroups';
import { changeSelected, getSectionSearch, removeAllUser, removeCustomGroup, removeSelectedPeople, setAllActive, getSections, addAll, setAllGroups, toggleAllUsers, changeSelectedOwner, removeSelectedOwner, removeAll, setAllSearched } from 'actions/ScheduleFilter';
import { clearActivitesForOther } from 'actions/schedule';

var ListSelector = function ListSelector() {
  var ScheduleFilter = useSelector(function (state) {
    return state.ScheduleFilter;
  });
  var sections = useSelector(function (state) {
    return state.sections.educationGroups;
  });
  var translate = getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  }));
  var dispatch = useDispatch();
  var currentUser = useSelector(function (state) {
    return state.user.currentUser;
  });

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsloading = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      isIopen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      displaySearch = _useState6[0],
      setDisplaySearch = _useState6[1]; //Handle searchedChecked


  var checkChecked = function checkChecked(id, newData) {
    var storedData = ScheduleFilter.userFilter.find(function (x) {
      return x.id === id;
    });

    if (!storedData) {
      return;
    }

    var existingStudents = storedData.students;
    var students = newData === null || newData === void 0 ? void 0 : newData.students.filter(function (x) {
      return !existingStudents.find(function (s) {
        return s.id == x.id;
      });
    });
    var existingOwners = storedData === null || storedData === void 0 ? void 0 : storedData.owners;
    var owners = newData === null || newData === void 0 ? void 0 : newData.owners.filter(function (x) {
      return !existingOwners.find(function (s) {
        return s.id == x.id;
      });
    });
    return {
      studentsCount: students === null || students === void 0 ? void 0 : students.length,
      ownersCount: owners === null || owners === void 0 ? void 0 : owners.length
    };
  };

  var fetchData = function fetchData(checked, id, button, data) {
    var ownerArr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var search = arguments.length > 5 ? arguments[5] : undefined;

    if (checked) {
      var _findExisting$, _findExisting$2;

      setIsOpen(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, true));
      });
      var findExisting;
      var countObject = {};

      if (search) {
        findExisting = ScheduleFilter.storedSearch.filter(function (x) {
          return x.id == id;
        });
      } else {
        findExisting = ScheduleFilter.customGroup.filter(function (x) {
          return x.id == id;
        });
      }

      if (!((_findExisting$ = findExisting[0]) !== null && _findExisting$ !== void 0 && _findExisting$.students) || !((_findExisting$2 = findExisting[0]) !== null && _findExisting$2 !== void 0 && _findExisting$2.owners)) {
        setIsloading(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, true));
        });

        if (button) {
          dispatch(getSections(id, true, currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, search)).then(function () {
            setIsloading(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, false));
            });
          })["catch"](function (e) {
            console.error(e);
          });
          return;
        }
      }

      var newData = JSON.parse(JSON.stringify(data));

      if (ownerArr != null) {
        newData.owners = ownerArr;
      }

      if (findExisting) {
        countObject = checkChecked(id, newData);
      }

      dispatch(setAllActive(id, [], newData, search, countObject));
      return;
    }

    setIsOpen(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, false));
    });

    if (search) {
      var _find = ScheduleFilter.storedSearch.filter(function (x) {
        return x.id !== id;
      });

      dispatch(removeAllUser(id, data, ownerArr, _find, true));
      return;
    }

    var find = ScheduleFilter.userFilter.filter(function (x) {
      return x.id !== id;
    });
    dispatch(removeAllUser(id, data, ownerArr, find, search));
  };

  var searchGroup = function searchGroup(values) {
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(values != null)) {
                  _context.next = 10;
                  break;
                }

                resolve(1); //check if searched items doesn't already exists in both stored and in section

                if (!(ScheduleFilter.storedSearch.filter(function (x) {
                  return x.id === values.group.id;
                }).length > 0)) {
                  _context.next = 5;
                  break;
                }

                setDisplaySearch(false);
                return _context.abrupt("return");

              case 5:
                if (!(sections.filter(function (x) {
                  return x.id === values.group.id;
                }).length > 0)) {
                  _context.next = 8;
                  break;
                }

                setDisplaySearch(false);
                return _context.abrupt("return");

              case 8:
                fetchData(true, values.group.id, true, [], [], true);
                setDisplaySearch(false);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  };

  var removeSearchedItem = function removeSearchedItem(id, object) {
    dispatch(removeCustomGroup(id, object));
    var getLength = ScheduleFilter.userFilter.filter(function (x) {
      return x.id !== id;
    });

    if (getLength.length === 0) {
      //clear searchedItems from store if selectedItems are empty
      dispatch(clearActivitesForOther());
    }
  }; //fetch all members of a section one by one


  var fetchAll = function fetchAll(fetchNew, searched) {
    var count = 0;
    var arr = [];
    var checked = {};
    var total = 0;
    var owners = 0;

    if (fetchNew) {
      //get all none selected items
      var getNoneItems = sections.filter(function (x) {
        return !ScheduleFilter.customGroup.find(function (t) {
          return t.id == x.id;
        });
      }); //make an api call to get every items

      getNoneItems.map( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(items) {
          var response, _object$owners$filter, _object$students$leng, object, _object, full;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  checked[items.id] = true;

                  if (!((ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.customGroup.find(function (x) {
                    return x.id == items.id;
                  })) === undefined)) {
                    _context2.next = 23;
                    break;
                  }

                  setIsloading(function (prev) {
                    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, items.id, true));
                  });
                  setIsOpen(function (prev) {
                    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, items.id, true));
                  });
                  _context2.prev = 4;
                  _context2.next = 7;
                  return addAll(items.id);

                case 7:
                  response = _context2.sent;

                  if (response) {
                    object = JSON.parse(JSON.stringify(response === null || response === void 0 ? void 0 : response.data));

                    if (object.owners == null) {
                      object.owners = [];
                    }

                    if (object.students == null) {
                      object.students = [];
                    }

                    owners += (_object$owners$filter = object.owners.filter(function (x) {
                      return x.id !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
                    }).length) !== null && _object$owners$filter !== void 0 ? _object$owners$filter : 0;
                    total += (_object$students$leng = object.students.length) !== null && _object$students$leng !== void 0 ? _object$students$leng : 0;
                    checked[items.id] = true;
                    arr.push(object);
                    count++;
                    setIsloading(function (prev) {
                      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, items.id, false));
                    });
                  }

                  _context2.next = 19;
                  break;

                case 11:
                  _context2.prev = 11;
                  _context2.t0 = _context2["catch"](4);
                  _object = JSON.parse(JSON.stringify(items));

                  if (_object.owners == null) {
                    _object.owners = [];
                  }

                  if (_object.students == null) {
                    _object.students = [];
                  }

                  checked[items.id] = true;
                  arr.push(_object);
                  count++;

                case 19:
                  if (!(getNoneItems.length === count)) {
                    _context2.next = 23;
                    break;
                  }

                  full = [].concat(_toConsumableArray(ScheduleFilter.customGroup), arr);
                  dispatch(setAllGroups(full, total, sections.length, [], checked));
                  return _context2.abrupt("return");

                case 23:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[4, 11]]);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }

    sections.map(function (items) {
      checked[items.id] = true;
    });

    if (searched) {
      var checkedSearched = JSON.parse(JSON.stringify(ScheduleFilter.storedSearch)).map(function (items) {
        checked[items.id] = true;
        items.owners = [];
        return items;
      });
      dispatch(setAllSearched(checkedSearched, checked));
      return;
    }

    dispatch(setAllGroups(ScheduleFilter.customGroup, null, null, false, checked));
  };

  var getActiveSearch = function getActiveSearch(groupId, objId, isOwner, search) {
    var _existingGroup2;

    var exists = false;
    var existingGroup;
    existingGroup = ScheduleFilter.userFilter.find(function (x) {
      return x.id === groupId;
    });

    if (isOwner) {
      var _existingGroup;

      if ((_existingGroup = existingGroup) !== null && _existingGroup !== void 0 && _existingGroup.owners) {
        existingGroup.owners.map(function (item) {
          if (item.id == objId) {
            exists = true;
            return;
          }
        });
      }

      if (exists) {
        return true;
      }
    }

    if ((_existingGroup2 = existingGroup) !== null && _existingGroup2 !== void 0 && _existingGroup2.students) {
      var _existingGroup3;

      (_existingGroup3 = existingGroup) === null || _existingGroup3 === void 0 ? void 0 : _existingGroup3.students.map(function (item) {
        if (item.id == objId) {
          exists = true;
          return;
        }
      });
    }

    if (exists) {
      return true;
    }

    return false;
  }; //change object by changing students or owners property


  var changeObj = function changeObj(userObj, newObj) {
    var _parseObj2;

    var isOwner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var search = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var getObj = ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.userFilter.find(function (x) {
      return x.id === userObj.id;
    });
    var parseObj;

    if (!getObj) {
      parseObj = JSON.parse(JSON.stringify(userObj));
    } else {
      parseObj = JSON.parse(JSON.stringify(getObj));
    }

    if (isOwner) {
      var _parseObj;

      if (!((_parseObj = parseObj) !== null && _parseObj !== void 0 && _parseObj.owners)) {
        parseObj.owners = [newObj];
      } else {
        parseObj.owners = parseObj.owners.filter(function (x) {
          return x.id !== newObj.id;
        }).concat(newObj);
      }

      return parseObj;
    }

    if (!((_parseObj2 = parseObj) !== null && _parseObj2 !== void 0 && _parseObj2.students)) {
      parseObj.students = [newObj];
    } else {
      parseObj.students = parseObj.students.filter(function (x) {
        return x.id !== newObj.id;
      }).concat(newObj);
    }

    return parseObj;
  };

  var handlePeopleSelection = function handlePeopleSelection(checked, userObj, obj) {
    var _newObj$owner;

    var owner = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var searchitems = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (checked) {
      //Store searchitems in a seperate array in redux
      if (searchitems) {
        var addPeople = JSON.parse(JSON.stringify(userObj));

        if (owner) {
          //Remove all owners from the stored object before adding new
          addPeople.owners = [];
          addPeople.students = [];
          dispatch(changeSelectedOwner(changeObj(addPeople, obj, true, true)));
          return;
        } //Remove all students from the stored object before adding new


        addPeople.students = [];
        addPeople.owners = [];
        dispatch(changeSelected(changeObj(addPeople, obj, false, true)));
        return;
      }

      if (owner) {
        dispatch(changeSelectedOwner(changeObj(userObj, obj, true)));
        return;
      }

      dispatch(changeSelected(changeObj(userObj, obj)));
      return;
    }

    if (searchitems) {
      var _searchObj$owner2;

      var _findItem = ScheduleFilter.userFilter.find(function (x) {
        return x.id === userObj.id;
      });

      var searchObj = JSON.parse(JSON.stringify(_findItem));

      if (owner) {
        var _searchObj$owner;

        var removedOwners = _findItem.owners.filter(function (x) {
          return x.id !== obj.id;
        }); //Clear fetchdata if both owner and students are empty


        searchObj.owners = removedOwners;

        if (searchObj.students.length === 0 && searchObj.owners.length === 0 && ScheduleFilter.userFilter.length === 1) {
          dispatch(clearActivitesForOther());
        }

        (_searchObj$owner = searchObj.owner) === null || _searchObj$owner === void 0 ? void 0 : _searchObj$owner.filter(function (x) {
          return x.id !== currentUser.id;
        });
        dispatch(removeSelectedOwner(searchObj));
        return;
      }

      var _removedStudents = _findItem.students.filter(function (x) {
        return x.id !== obj.id;
      });

      searchObj.students = _removedStudents; //Clear fetchdata if both owner and students are empty

      if (searchObj.students.length === 0 && searchObj.owners.length === 0 && ScheduleFilter.userFilter.length === 1) {
        dispatch(clearActivitesForOther());
      }

      (_searchObj$owner2 = searchObj.owner) === null || _searchObj$owner2 === void 0 ? void 0 : _searchObj$owner2.filter(function (x) {
        return x.id !== currentUser.id;
      });
      dispatch(removeSelectedPeople(searchObj));
      return;
    }

    var findItem = ScheduleFilter.userFilter.find(function (x) {
      return x.id === userObj.id;
    });
    var newObj = JSON.parse(JSON.stringify(findItem));

    if (owner) {
      var _removedOwners = findItem.owners.filter(function (x) {
        return x.id !== obj.id && x.id !== currentUser.id;
      });

      newObj.owners = _removedOwners;
      dispatch(removeSelectedOwner(newObj));
      return;
    }

    var removedStudents = findItem.students.filter(function (x) {
      return x.id !== obj.id;
    });
    newObj.students = removedStudents;
    (_newObj$owner = newObj.owner) === null || _newObj$owner === void 0 ? void 0 : _newObj$owner.filter(function (x) {
      return x.id !== currentUser.id;
    });
    dispatch(removeSelectedPeople(newObj));
  };

  var handlePlus = function handlePlus(open, id, search) {
    var _findExisting$3;

    if (open) {
      setIsOpen(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, false));
      });
      return;
    }

    var findExisting;

    if (search) {
      findExisting = findExisting = ScheduleFilter.storedSearch.filter(function (x) {
        return x.id == id;
      });
    } else {
      findExisting = ScheduleFilter.customGroup.filter(function (x) {
        return x.id == id;
      });
    }

    setIsOpen(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, true));
    });

    if (!((_findExisting$3 = findExisting[0]) !== null && _findExisting$3 !== void 0 && _findExisting$3.students)) {
      setIsloading(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, true));
      });

      if (search) {
        dispatch(getSectionSearch(id, false, currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)).then(function () {
          setIsloading(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, false));
          });
        })["catch"](function (e) {
          console.error(e);
          setIsloading(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, false));
          });
        });
        return;
      }

      dispatch(getSections(id, false, currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)).then(function () {
        setIsloading(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, false));
        });
      })["catch"](function (e) {
        console.error(e);
        setIsloading(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, id, false));
        });
      });
      return;
    }
  };

  var handleAll = function handleAll(checked) {
    if (checked) {
      var _ScheduleFilter$store;

      //select all Searched
      if (((_ScheduleFilter$store = ScheduleFilter.storedSearch) === null || _ScheduleFilter$store === void 0 ? void 0 : _ScheduleFilter$store.length) > 0) {
        fetchAll(false, true);
      }

      if (ScheduleFilter.totalGroups >= sections.length) {
        fetchAll(false);
      } else {
        fetchAll(true);
      }

      dispatch(toggleAllUsers());
    }

    if (!checked) {
      setIsOpen({});
      dispatch(removeAll());
    }
  }; // increase zIndex to allow this component to temporary overlapp the c--sider menu 


  useEffect(function () {
    var element = document.querySelector('.c--content');

    if (element) {
      element.style.zIndex = 2;
    }

    return function () {
      var element = document.querySelector('.c--content');

      if (element) {
        element.style.zIndex = 1;
      }
    };
  }, []);
  var groupsSelectedCount = useMemo(function () {
    return Object.keys(ScheduleFilter.selectedGroups).filter(function (key) {
      return ScheduleFilter.selectedGroups[key];
    }).length;
  }, [ScheduleFilter.selectedGroups]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: '2rem'
    }
  }, sections === null ? /*#__PURE__*/React.createElement("div", {
    className: "listLoader"
  }, /*#__PURE__*/React.createElement(Spinner, {
    small: true,
    center: true
  })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "toolTip_groups_header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "".concat(translate('Students'), ": ").concat(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.selectedPeople))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "".concat(translate('Owner'), ": ").concat(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.ownersSelected)))), /*#__PURE__*/React.createElement(Checkbox, {
    value: groupsSelectedCount == sections.length,
    onChange: handleAll,
    label: translate('select-all')
  }), /*#__PURE__*/React.createElement("div", {
    className: "expendable-Header"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--size-14)',
      fontWeight: 500
    }
  }, translate('My groups'))), sections.map(function (items) {
    items.owners = [];
    items.students = [];
    var groupData = ScheduleFilter.customGroup.find(function (x) {
      return x.id == items.id;
    });
    var filterData = ScheduleFilter.userFilter.find(function (x) {
      return x.id == items.id;
    });
    var owners = [];
    var groupIsIndeterminate = false;
    var groupIsActive = false;

    if (groupData !== null && groupData !== void 0 && groupData.owners) {
      owners = groupData.owners.filter(function (x) {
        return x.id !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
      });
    }

    if (groupData != null && filterData != null) {
      var selectedCount = filterData.students.length + filterData.owners.filter(function (x) {
        return x.id !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
      }).length;
      var totalCount = groupData.students.length + owners.length;

      if (selectedCount > 0) {
        groupIsIndeterminate = totalCount != selectedCount;
        groupIsActive = totalCount == selectedCount;
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "expendable-Header",
      key: items.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      value: groupIsActive,
      indeterminate: groupIsIndeterminate,
      label: items.title,
      onChange: function onChange() {
        if (groupIsActive) {
          fetchData(false, items.id, true, groupData, owners);
        } else {
          if (groupIsIndeterminate) {
            fetchData(true, items.id, true, groupData, owners);
          } else {
            fetchData(true, items.id, true, groupData, []);
          }
        }
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "groupOwner"
    }, translate('Owner'))), /*#__PURE__*/React.createElement("button", {
      className: "trigger-button",
      onClick: function onClick() {
        return handlePlus(isIopen[items.id], items.id);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "trigger"
    }, isIopen[items.id] ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null))), /*#__PURE__*/React.createElement("div", {
      className: "subSection"
    }, isIopen[items.id] ? /*#__PURE__*/React.createElement(Fragment, null, isLoading[items.id] && /*#__PURE__*/React.createElement("div", {
      className: "listLoader"
    }, /*#__PURE__*/React.createElement(Spinner, {
      small: true,
      center: true
    })), /*#__PURE__*/React.createElement("div", null, owners.map(function (owners) {
      return /*#__PURE__*/React.createElement("div", {
        key: owners.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: getActiveSearch(items.id, owners.id, true),
        label: /*#__PURE__*/React.createElement("span", null, owners.firstName, ' ', owners.lastName, /*#__PURE__*/React.createElement("span", {
          className: "groupOwner"
        }, translate('Owner'))),
        onChange: function onChange(checked) {
          return handlePeopleSelection(checked, items, owners, true);
        }
      })));
    }), groupData === null || groupData === void 0 ? void 0 : groupData.students.map(function (student) {
      return /*#__PURE__*/React.createElement("div", {
        key: student.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: getActiveSearch(items.id, student.id),
        label: /*#__PURE__*/React.createElement("div", null, student.firstName, ' ', student.lastName),
        onChange: function onChange(checked) {
          return handlePeopleSelection(checked, items, student);
        }
      })));
    }))) : null));
  }), /*#__PURE__*/React.createElement("div", {
    className: "searchStudents"
  }, (ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.storedSearch.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "expendable-Header"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--size-14)',
      fontWeight: 500
    }
  }, translate('Other groups'))) : null, ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.storedSearch.map(function (items) {
    var groupData = ScheduleFilter.storedSearch.find(function (x) {
      return x.id === items.id;
    });
    var filterData = ScheduleFilter.userFilter.find(function (x) {
      return x.id == items.id;
    });
    var owners = [];
    var groupIsIndeterminate = false;
    var groupIsActive = false;

    if (groupData !== null && groupData !== void 0 && groupData.owners) {
      owners = groupData.owners.filter(function (x) {
        return x.id !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
      });
    }

    if (groupData != null && filterData != null) {
      var selectedCount = filterData.students.length + filterData.owners.filter(function (x) {
        return x.id !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
      }).length;
      var totalCount = groupData.students.length + owners.length;

      if (selectedCount > 0) {
        groupIsIndeterminate = totalCount != selectedCount;
        groupIsActive = totalCount == selectedCount;
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "expendable-Header",
      key: items.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      value: groupIsActive,
      indeterminate: groupIsIndeterminate,
      label: items.title,
      onChange: function onChange() {
        if (groupIsActive) {
          fetchData(false, items.id, true, groupData, owners, true);
        } else {
          if (groupIsIndeterminate) {
            fetchData(true, items.id, true, groupData, owners, true);
          } else {
            fetchData(true, items.id, true, groupData, [], true);
          }
        }
      }
    }), ' ', /*#__PURE__*/React.createElement("button", {
      className: "removeStudentSearch",
      onClick: function onClick() {
        return removeSearchedItem(items.id, groupData);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Close"
    }))), /*#__PURE__*/React.createElement("button", {
      className: "trigger-button",
      onClick: function onClick() {
        return handlePlus(isIopen[items.id], items.id, true);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "trigger"
    }, isIopen[items.id] ? /*#__PURE__*/React.createElement(Minus, null) : /*#__PURE__*/React.createElement(Plus, null))), /*#__PURE__*/React.createElement("div", {
      className: "subSection"
    }, isIopen[items.id] ? /*#__PURE__*/React.createElement(Fragment, null, isLoading[items.id] && /*#__PURE__*/React.createElement("div", {
      className: "listLoader"
    }, /*#__PURE__*/React.createElement(Spinner, {
      small: true,
      center: true
    })), /*#__PURE__*/React.createElement("div", null, owners.map(function (owners) {
      return /*#__PURE__*/React.createElement("div", {
        key: owners.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: getActiveSearch(items.id, owners.id, true, true),
        label: /*#__PURE__*/React.createElement("span", null, owners.firstName, ' ', owners.lastName, /*#__PURE__*/React.createElement("span", {
          className: "groupOwner"
        }, " ", translate('Owner'))),
        onChange: function onChange(checked) {
          return handlePeopleSelection(checked, items, owners, true, true);
        }
      })));
    }), groupData === null || groupData === void 0 ? void 0 : groupData.students.map(function (student) {
      return /*#__PURE__*/React.createElement("div", {
        key: student.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: getActiveSearch(items.id, student.id, false, true),
        label: /*#__PURE__*/React.createElement("div", null, student.firstName, ' ', student.lastName),
        onChange: function onChange(checked) {
          return handlePeopleSelection(checked, items, student, false, true);
        }
      })));
    }))) : null));
  })), /*#__PURE__*/React.createElement(Collapsible, {
    trigger: translate('Add group')
  }, /*#__PURE__*/React.createElement(SearchGroups, {
    onSubmit: searchGroup
  }))));
};

export default ListSelector;